export default __webpack_public_path__ + "static/media/signup-arrow.f4b1e90b.svg";